import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { Header } from "../Header-Assesment/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./maincontent-physical.css";
import { TabBar } from "../Components/Tab-bar";
import ArrowCircleRight from "../../../assets/ArrowCircleRight.svg";

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

export const AssessmentTemplate = ({
  headerTitle,
  headerSubtitle,
  breadcrumbs,
  tags,
  title,
  subtitle,
  image,
  badgeText,
  buttonText,
  onButtonClick,
}) => {
  const { domain } = useParams(); 
  const navigate = useNavigate(); 
  
  const tabFlow = [
    "physical",
    "emotional",
    "acceptance",
    "relationships",
    "loving kindness",
    "intellectual",
  ];


  const [completedTabs, setCompletedTabs] = useState([capitalize(domain)]);


  const currentIndex = tabFlow.indexOf(domain);


  const completedTabsList = tabFlow
    .slice(0, currentIndex)
    .map(capitalize); 


  const handleNextTab = () => {
    const currentDomain = domain;  
    const nextIndex = currentIndex + 1;
    const nextDomain = tabFlow[nextIndex]; 

 
    if (!completedTabs.includes(capitalize(currentDomain))) {
      setCompletedTabs([...completedTabs, capitalize(currentDomain)]);
    }

   
    navigate(`/Question-card/${currentDomain}`, {
      state: { nextDomain: nextDomain || null }, 
    });
  };

  return (
    <div className="maincontent-physical">
      <div className="header-assessment">
        <Header title={headerTitle} subtitle={headerSubtitle} />
      </div>

      <div className="toppart">
        <div className="breadcrumb">
          {breadcrumbs.map((crumb, i) => (
            <React.Fragment key={i}>
              {crumb.icon && (
                <FontAwesomeIcon
                  icon={crumb.icon}
                  style={{ color: "#c1c0bd" }}
                />
              )}
              <p className={crumb.active ? "element-text3" : "element-text"}>
                {crumb.text}
              </p>
              {i !== breadcrumbs.length - 1 && <p className="overline">/</p>}
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="mainpart-physical">
        <div className="assessments">
          <div className="frame-1">
            <TabBar
              activeTab={(domain)}
              // activeTab={capitalize(domain)}  
              setActiveTab={() => {}}
              completedTabs={completedTabsList} 
              
            />
          </div>

          <div className="frame-2">
            <p className="title-main">{title}</p>
            <p className="subtitle-main">{subtitle}</p>
          </div>

          <div className="frame-3">
            <img className="physical-image" src={image} alt="Assessment" />
          </div>

          <div className="frame-4">
            <p className="bedge-text">{badgeText}</p>
          </div>

          <div className="frame-5">
            <button
              className="button-physical"
              onClick={handleNextTab}
            >
              <span className="button-text">{buttonText}</span>
              <img className="button-arrow" src={ArrowCircleRight} alt="Arrow" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
